import { render, staticRenderFns } from "./BoletoView.vue?vue&type=template&id=4c75e7c8&scoped=true&"
import script from "./BoletoView.vue?vue&type=script&lang=js&"
export * from "./BoletoView.vue?vue&type=script&lang=js&"
import style0 from "./BoletoView.vue?vue&type=style&index=0&id=4c75e7c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c75e7c8",
  null
  
)

export default component.exports